module.exports = __webpack_public_path__ + "img/orange_134.55181a18.png";